// export async function  getData(id) {
//     const {data} = await base.from('familytree').select().eq('id',id)
//     return data[0]
// }
import { supabase } from '@/utils/supabase'
export async function  getAll() {
    const {data} = await supabase.from('relation').select().order('id', { ascending: false })
    return data
}
